/**
 * Homepage story slider with automatic and manual controls.
 *
 * @package DemocraticTools
 */

const AUTO_ADVANCE_MS = 7000;

export function initStorySlider({
  setIntervalFn = globalThis.setInterval,
  clearIntervalFn = globalThis.clearInterval,
  matchMedia = globalThis.matchMedia,
} = {}) {
  const sliders = document.querySelectorAll("[data-story-slider]");

  for (const slider of sliders) {
    const slides = [...slider.querySelectorAll("[data-story-slide]")];

    if (slides.length < 2) {
      continue;
    }

    const previous = slider.querySelector("[data-story-previous]");
    const next = slider.querySelector("[data-story-next]");
    const indicators = [...slider.querySelectorAll("[data-story-index]")];
    const status = slider.querySelector(".dt-story-slider__status");
    const toggle = slider.querySelector("[data-story-toggle]");
    let activeIndex = 0;
    let timer = null;
    let playing = false;

    const showStory = (index) => {
      activeIndex = (index + slides.length) % slides.length;

      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === activeIndex;
        slide.hidden = !isActive;
        slide.classList.toggle("is-active", isActive);
        slide.setAttribute("aria-hidden", String(!isActive));
      });

      indicators.forEach((indicator, indicatorIndex) => {
        indicator.setAttribute(
          "aria-current",
          String(indicatorIndex === activeIndex),
        );
      });

      status.textContent = `${activeIndex + 1} / ${slides.length}`;
    };

    const updateToggle = () => {
      toggle.textContent = playing ? "Pause" : "Play";
      toggle.setAttribute(
        "aria-label",
        playing ? "Pause slideshow" : "Play slideshow",
      );
    };

    const stop = () => {
      if (timer !== null) {
        clearIntervalFn(timer);
        timer = null;
      }

      playing = false;
      updateToggle();
    };

    const start = () => {
      timer = setIntervalFn(() => showStory(activeIndex + 1), AUTO_ADVANCE_MS);
      playing = true;
      updateToggle();
    };

    slider.classList.add("is-enhanced");
    previous.addEventListener("click", () => showStory(activeIndex - 1));
    next.addEventListener("click", () => showStory(activeIndex + 1));

    indicators.forEach((indicator) => {
      indicator.addEventListener("click", () =>
        showStory(Number(indicator.dataset.storyIndex)),
      );
    });

    toggle.addEventListener("click", () => {
      if (playing) {
        stop();
      } else {
        start();
      }
    });

    showStory(0);

    if (typeof matchMedia === "function" && matchMedia("(prefers-reduced-motion: reduce)").matches) {
      updateToggle();
    } else {
      start();
    }
  }
}
